// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.simx-tag {
  background: rgb(255, 255, 255);
  border: solid 1px rgb(194.5833333333, 206.6666666667, 206.6666666667);
  border-radius: 4px;
  display: inline-flex;
  align-items: center;
  padding: 2px;
  position: relative;
}
.simx-tag.simx-checkable {
  cursor: pointer;
}
.simx-tag.simx-style--alert {
  background: rgb(229, 0, 44);
  border: none;
  padding: 3px;
}
.simx-tag.simx-style--alert .simx-tag--content {
  color: rgb(255, 255, 255);
  font-size: 0.875em;
  font-weight: 600;
  text-transform: uppercase;
}

.simx-tag--content {
  padding: 0 6px;
}

.simx-tag--check-block {
  background: rgb(255, 255, 255);
  border: solid 1px rgb(194.5833333333, 206.6666666667, 206.6666666667);
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 4px;
  padding: 1px;
  width: 15px;
  height: 15px;
}
.simx-tag--check-block .simx-icon {
  opacity: 0;
  transition: opacity 0.2s;
}
.simx-tag--check-block .simx-icon path {
  fill: rgb(123.75, 150, 150);
}
.simx-tag.simx-checked .simx-tag--check-block .simx-icon {
  opacity: 1;
}

.simx-tag--remove-action {
  appearance: none;
  background: none;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  display: block;
  margin: 0;
  padding: 2px;
  transition: background 0.2s;
  width: 25px;
  height: 25px;
}
.simx-tag--remove-action .simx-icon {
  width: 100%;
  height: 100%;
}
.simx-tag--remove-action .simx-icon path {
  fill: rgb(123.75, 150, 150);
  transition: fill 0.2s;
}
.simx-tag--remove-action:hover:not(:active) {
  background-color: rgb(159.1666666667, 178.3333333333, 178.3333333333);
}
.simx-tag--remove-action:hover:not(:active) .simx-icon path {
  fill: rgb(255, 255, 255);
}
.simx-tag--remove-action:active {
  background-color: rgb(123.75, 150, 150);
}
.simx-tag--remove-action:active .simx-icon path {
  fill: rgb(255, 255, 255);
}`, "",{"version":3,"sources":["webpack://./src/app/modules/ui-elements/components/elements/tag/tag.component.scss","webpack://./src/assets/styles/_colors.scss","webpack://./src/assets/styles/_theme.scss"],"names":[],"mappings":"AAGA;EACE,8BCY8B;EDX9B,qEAAA;EACA,kBEN4B;EFO5B,oBAAA;EACE,mBAAA;EACF,YAAA;EACA,kBAAA;AAFF;AAIE;EACE,eAAA;AAFJ;AAKE;EACE,2BCf4B;EDgB5B,YAAA;EACA,YAAA;AAHJ;AAKI;EACE,yBCN0B;EDO1B,kBAAA;EACA,gBAAA;EACA,yBAAA;AAHN;;AAQA;EACE,cAAA;AALF;;AAQA;EACE,8BCnB8B;EDoB9B,qEAAA;EACA,kBErC4B;EFsC5B,eAAA;EACA,aAAA;EACE,mBAAA;EACA,uBAAA;EACF,gBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;AALF;AAOE;EACE,UAAA;EACA,wBAAA;AALJ;AAOI;EACE,2BCrC0B;ADgChC;AAUI;EACE,UAAA;AARN;;AAaA;EACE,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,kBEnE4B;EFoE5B,eAAA;EACA,cAAA;EACA,SAAA;EACA,YAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;AAVF;AAYE;EACE,WAAA;EACA,YAAA;AAVJ;AAYI;EACE,2BClE0B;EDmE1B,qBAAA;AAVN;AAcE;EACE,qECzE4B;AD6DhC;AAeM;EACE,wBC3EwB;AD8DhC;AAkBE;EACE,uCClF4B;ADkEhC;AAmBM;EACE,wBCrFwB;ADoEhC","sourcesContent":["@use 'colors';\n@use 'theme';\n\n.simx-tag {\n  background: colors.$simxColorWhite;\n  border: solid 1px colors.$simxColorLightNeutralDark;\n  border-radius: theme.$simxBorderRadiusDefault;\n  display: inline-flex;\n    align-items: center;\n  padding: 2px;\n  position: relative;\n\n  &.simx-checkable {\n    cursor: pointer;\n  }\n\n  &.simx-style--alert {\n    background: colors.$simxColorBrightAccent;\n    border: none;\n    padding: 3px;\n\n    .simx-tag--content {\n      color: colors.$simxColorWhite;\n      font-size: 0.875em;\n      font-weight: 600;\n      text-transform: uppercase;\n    }\n  }\n}\n\n.simx-tag--content {\n  padding: 0 6px;\n}\n\n.simx-tag--check-block {\n  background: colors.$simxColorWhite;\n  border: solid 1px colors.$simxColorLightNeutralDark;\n  border-radius: theme.$simxBorderRadiusDefault;\n  cursor: pointer;\n  display: flex;\n    align-items: center;\n    justify-content: center;\n  margin-left: 4px;\n  padding: 1px;\n  width: 15px;\n  height: 15px;\n\n  .simx-icon {\n    opacity: 0;\n    transition: opacity theme.$simxTransitionSpeedDefault;\n\n    path {\n      fill: colors.$simxColorLightNeutralDarkest;\n    }\n  }\n\n  .simx-tag.simx-checked & {\n    .simx-icon {\n      opacity: 1;\n    }\n  }\n}\n\n.simx-tag--remove-action {\n  appearance: none;\n  background: none;\n  border: none;\n  border-radius: theme.$simxBorderRadiusDefault;\n  cursor: pointer;\n  display: block;\n  margin: 0;\n  padding: 2px;\n  transition: background theme.$simxTransitionSpeedDefault;\n  width: 25px;\n  height: 25px;\n\n  .simx-icon {\n    width: 100%;\n    height: 100%;\n\n    path {\n      fill: colors.$simxColorLightNeutralDarkest;\n      transition: fill theme.$simxTransitionSpeedDefault;\n    }\n  }\n\n  &:hover:not(:active) {\n    background-color: colors.$simxColorLightNeutralDarker;\n\n    .simx-icon {\n      path {\n        fill: colors.$simxColorWhite;\n      }\n    }\n  }\n\n  &:active {\n    background-color: colors.$simxColorLightNeutralDarkest;\n\n    .simx-icon {\n      path {\n        fill: colors.$simxColorWhite;\n      }\n    }\n  }\n}\n","@use 'sass:color';\n\n$simxColorBrightAccent:         rgb(229, 0, 44);  // Red\n$simxColorDarkAccent:           rgb(54, 47, 65);  // Purple\n$simxColorBrightGreen:          rgb(0, 201, 133);\n$simxColorMustard:              rgb(255, 177, 0);\n\n$simxColorDarkAccentMedium:     color.adjust($simxColorDarkAccent, $lightness: 6%);\n$simxColorDarkAccentLight:      color.adjust($simxColorDarkAccent, $lightness: 53%);\n$simxColorDarkNeutral:          rgb(21, 19, 25);\n$simxColorDarkNeutralLight:     color.adjust(color.adjust($simxColorDarkNeutral, $saturation: -7%), $lightness: 76%);\n$simxColorLightNeutral:         rgb(230, 235, 235);\n$simxColorLightNeutralLight:    color.adjust($simxColorLightNeutral, $lightness: 5%);\n$simxColorLightNeutralDark:     color.adjust($simxColorLightNeutral, $lightness: -12.5%);\n$simxColorLightNeutralDarker:   color.adjust($simxColorLightNeutral, $lightness: -25%);\n$simxColorLightNeutralDarkest:  color.adjust($simxColorLightNeutral, $lightness: -37.5%);\n$simxColorWhite:                rgb(255, 255, 255);\n\n$simxColorTextDefault:          $simxColorDarkNeutral;\n$simxColorTextLight:            rgb(166, 167, 169);\n$simxColorTextInvert:           rgba(255, 255, 255, 0.95);\n$simxColorTextOverDarkAccent:   rgba($simxColorWhite, 0.95);\n\n$simxColorControlBackground:    $simxColorWhite;\n$simxColorControlBorder:        $simxColorLightNeutralDark;\n","$simxBorderRadiusDefault:     4px;\n$simxBorderRadiusHeavy:       calc($simxBorderRadiusDefault * 2);\n\n$simxTransitionSpeedDefault:  0.2s;\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
